import React, { useMemo, useState } from "react";
import { useImmer } from "use-immer";

export const StepStatus = {
  LOADING: "loading",
  ERROR: "error",
  INIT: "init",
  FINISH: "finish",
};

export const DEFAULT_VALUE = {
  address: "",
  symbol: "",
  decimal: "",
  image: "",
  loanToValue: "",
  lt: "",
  reserveFactor: "",
  liquidationBonus: "",
  utilizationOptimal: "",
  slope1: "",
  slope2: "",
  baseInterestRate: "",
};

const AddAssetContext = React.createContext({
  stepStatus: { activeStep: 0, activeStatus: StepStatus.INIT, selectedStep: 0 },
  assets: [],
  setter: { setStepStatus: () => {}, setAssets: () => {} },
});

const INIT_STATE = {
  activeStep: 0,
  activeStatus: StepStatus.INIT,
  selectedStep: 0,
};

const AddAssetProvider = ({ children }) => {
  const [stepStatus, setStepStatus] = useImmer(INIT_STATE);
  const [assets, setAssets] = useState([]);

  const contextData = useMemo(
    () => ({
      stepStatus,
      assets,
      setter: { setStepStatus, setAssets },
    }),
    [stepStatus, assets]
  );

  return <AddAssetContext.Provider value={contextData}>{children}</AddAssetContext.Provider>;
};

export default AddAssetProvider;

export const useAddAssetContext = () => React.useContext(AddAssetContext);
